import { useEffect, useRef } from 'react'

import {
  useGuestProductCreationFunnel,
  useProductCreationFunnel,
} from '@fourthwall/module-tracking/react'
import { useAnalyticsManager } from '@hooks'

export const useOfferPreviewTracking = ({
  offerId,
  productId,
}: {
  offerId?: string
  productId?: string
}) => {
  const eventSent = useRef(false)
  const analyticsManager = useAnalyticsManager()
  const { trackStep } = useProductCreationFunnel(analyticsManager, {
    offer_id: offerId,
    product_id: productId,
  })
  const { trackStep: guestTrackStep } = useGuestProductCreationFunnel(analyticsManager, {
    offer_id: offerId,
    product_id: productId,
  })

  useEffect(() => {
    if (!offerId || !productId || eventSent.current) return

    trackStep('offer_preview_entry')
    guestTrackStep('offer_preview_entry')

    eventSent.current = true
  }, [guestTrackStep, offerId, productId, trackStep])
}
